import { render, staticRenderFns } from "./gisGrid.vue?vue&type=template&id=2445deff"
import script from "./gisGrid.vue?vue&type=script&lang=js"
export * from "./gisGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports